import { Injectable } from "@angular/core";
import { CONFIGURATION } from "../../../app.constants";
import { Observable } from "rxjs/Observable";
import { HttpDataService} from "../../../services/shared";

@Injectable()
export class AppInfoService {

    constructor(private httpData: HttpDataService) { }
    public GetGetElearningUrl(): Observable<string> {

        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "elearning/loginUrl")
                .map(response => <string>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
    public GetClientApplicationToken(applicationId: string): Observable<string> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}application/GetApplicationToken/${applicationId}`;
        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <string>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/applications/appInfo.service.ts